export enum TagBidLabel {
    Quoted = "Cotado",
    TopOffer = "Oferta no topo",
    Outbid = "Oferta ultrapassada",
    Finished = "Encerrado"
}
